import React, { FunctionComponent } from "react";

import { DatePickerField, ToggleField, useFieldContext } from "@bps/fluent-ui";
import { FormUsersSelect } from "@components/form/fields/FormUsersSelect";

import { FormLicenceTypesSelect } from "./FormLicenceTypesSelect";
import { FormProductTypesSelect } from "./FormProductSelect";

interface LicenceFormFieldsProps {
  isManagedLicence: boolean;
  tenantId: string;
}

export const LicenceFormFields: FunctionComponent<LicenceFormFieldsProps> = ({
  isManagedLicence,
  tenantId
}) => {
  const licenceTypeCode = useFieldContext<string>("licenceTypeCode");

  return (
    <>
      <FormLicenceTypesSelect
        required
        label="Licence type code"
        name="licenceTypeCode"
        disabled={isManagedLicence}
      />
      <FormProductTypesSelect
        required
        name="productId"
        label="Product"
        licenceTypeCode={licenceTypeCode.value}
        disabled={isManagedLicence}
      />
      <FormUsersSelect
        label="User"
        name="userId"
        tenantId={tenantId}
        activeOnly={true}
      />
      <DatePickerField
        required
        label="Expiry"
        name="expiryDate"
        disabled={isManagedLicence}
        minDate={new Date()}
      />
      <ToggleField label="Enabled" name="isActive" />
    </>
  );
};
